export const SHIPPING_BY_COUNTRY = {
  TR: { TRY: 0, USD: 0, EUR: 0, GBP: 0 },
  AU: { TRY: 4600, USD: 75, EUR: 65, GBP: 55 },
};

// Aynı sabit ücret planı: TR ücretsiz, diğerlerde tek sabit ücret
export const DEFAULT_SHIPPING_BY_CURRENCY = {
  TRY: 0,
  USD: 75,
  EUR: 65,
  GBP: 55,
};

// Avrupa ülke kodları, tek ülke listesi yerine tek sabit ve tek ücret için kullanılacak
export const EUROPE_COUNTRY_CODES = new Set([
  "AL",
  "AD",
  "AM",
  "AT",
  "AZ",
  "BE",
  "BA",
  "BG",
  "BY",
  "CH",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GE",
  "GI",
  "GR",
  "HR",
  "HU",
  "IE",
  "IS",
  "IT",
  "KZ",
  "LI",
  "LT",
  "LU",
  "LV",
  "MC",
  "MD",
  "ME",
  "MK",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "RS",
  "RU",
  "SE",
  "SI",
  "SK",
  "SM",
  "TR",
  "UA",
  "UK",
  "VA",
  "XK",
  "GB",
]);

export const COUNTRY_NAME_TO_CODE = {
  TURKEY: "TR",
  TURKIYE: "TR",
  TÜRKİYE: "TR",
  TR: "TR",
  "UNITED KINGDOM": "GB",
  UK: "GB",
  "GREAT BRITAIN": "GB",
  ENGLAND: "GB",
  GB: "GB",
  GERMANY: "DE",
  FRANCE: "FR",
  ITALY: "IT",
  SPAIN: "ES",
  NETHERLANDS: "NL",
  EUROPE: "EU",
};

const normalizeCurrency = (currency = "TRY") =>
  String(currency || "TRY").toUpperCase();

const normalizeCountryCode = (countryOrCode = "") => {
  const raw = String(countryOrCode || "").trim();
  if (!raw) return "";

  const upper = raw.toUpperCase();
  if (upper.length === 2) return upper;

  const match = COUNTRY_NAME_TO_CODE[upper] || COUNTRY_NAME_TO_CODE[raw];
  if (match) return match;

  // Türkiye / İngiltere gibi benzer isimleri çevreleyen küçük farklar
  if (["TURKIYE", "TÜRKİYE", "TURKEY"].includes(upper)) return "TR";
  if (["UK", "UNITED KINGDOM", "ENGLAND", "GREAT BRITAIN"].includes(upper))
    return "GB";

  return "";
};

export const getShippingFee = (
  countryCode = "",
  currency = "TRY",
  itemCount = 1,
) => {
  const normalizedCode = normalizeCountryCode(countryCode);
  const normalizedCurrency = normalizeCurrency(currency);
  const quantity = Math.max(1, Number(itemCount) || 1);

  // Türkiye her zaman ücretsiz
  if (normalizedCode === "TR") return 0;

  // Para birimi EUR/USD/GBP ise sabit default veya ülke map'ini kullan
  if (["USD", "EUR", "GBP"].includes(normalizedCurrency)) {
    const mapFee = Number(
      SHIPPING_BY_COUNTRY[normalizedCode]?.[normalizedCurrency] || 0,
    );
    const unitFee =
      mapFee > 0
        ? mapFee
        : Number(DEFAULT_SHIPPING_BY_CURRENCY[normalizedCurrency] || 0);

    return unitFee * quantity;
  }

  // TRY görünümündeyse TR dışında haritada fee varsa onu kullansın. Aksi halde ücretsiz görsün.
  if (normalizedCurrency === "TRY") {
    const mapFee = Number(SHIPPING_BY_COUNTRY[normalizedCode]?.TRY || 0);
    return mapFee * quantity;
  }

  // Fallback: map verisi veya default
  const unitFee = Number(
    SHIPPING_BY_COUNTRY[normalizedCode]?.[normalizedCurrency] ||
      DEFAULT_SHIPPING_BY_CURRENCY[normalizedCurrency] ||
      0,
  );

  return unitFee * quantity;
};

export const getShippingFeeFromStorage = (currency = "TRY", itemCount = 1) => {
  const rawCountry =
    localStorage.getItem("selectedCountry") ||
    localStorage.getItem("shipping_country") ||
    localStorage.getItem("country") ||
    "";

  return getShippingFee(rawCountry, currency, itemCount);
};
